<router-outlet />
<app-analytics-consent />
